import Sheet from "react-modal-sheet";
import { useEffect, useRef, useState } from "react";
import css from "./ShowAttachedImageBtn.module.scss";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import useSession from "@/template/live/useSession";
import useQuestion from "@/template/live/useQuestion";
import map from "lodash/map";
import { Button } from "@mui/material";
import SheetHeader from "@/comp/SheetHeader";
import useAttachedImage from "@/template/live/useAttachedImage";
import ThemeProviderShowAttachBtn from "@/template/live/ShowAttachedImageBtn/ThemeProviderShowAttachBtn";

type Props = {};

const ShowAttachedImageBtn = (props: Props) => {
  const [isOpenSheet, setOpenSheet] = useState(false);
  const { activeSessionId, sessionStatus, activeSessionObj } = useSession();
  const { activeQuiz } = useQuestion(activeSessionId[1]);

  const { showBtn, setshowBtn, currentAttachedImage, attachedImageStates } =
    useAttachedImage(activeSessionObj);

  const sheetOptions = {
    snapPoints: [-60],
  };

  const closeSheet = () => {
    setOpenSheet(false);
  };

  useEffect(() => {
    let isShow = false;
    if (activeQuiz.status == 1 || activeQuiz.status == 7) {
      map(attachedImageStates, (value, key) => {
        if (key === activeQuiz.activeQuiz) {
          isShow = true;
        }
      });
    }

    setshowBtn(isShow);
  }, [attachedImageStates, activeQuiz]);

  return (
    <>
      {showBtn && (
        <ThemeProviderShowAttachBtn>
          <div className={`${css["btnWrap"]}`}>
            <Button
              variant="contained"
              className={`${css["btn"]}`}
              onClick={() => {
                setOpenSheet(true);
              }}
            >
              <p className={`${css["btnText"]}`}>
                {attachedImageBtnText || "画像を表示"}
              </p>
            </Button>
          </div>
        </ThemeProviderShowAttachBtn>
      )}

      <Sheet isOpen={isOpenSheet} onClose={closeSheet} {...sheetOptions}>
        <Sheet.Container>
          <Sheet.Header>
            <SheetHeader setOpen={setOpenSheet} />
          </Sheet.Header>
          <Sheet.Content disableDrag={true}>
            <TransformWrapper>
              <TransformComponent
                wrapperStyle={{
                  width: "100%",
                  height: "100%",
                }}
                contentStyle={{
                  width: "100%",
                  height: "100%",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    padding: 30,
                    boxSizing: "border-box",
                    // backgroundColor: "#ccc",
                  }}
                >
                  <img
                    style={{
                      display: "block",
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                    src={currentAttachedImage}
                    alt=""
                  />
                </div>
              </TransformComponent>
            </TransformWrapper>
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={closeSheet} />
      </Sheet>
    </>
  );
};

export default ShowAttachedImageBtn;
